import { Component, OnInit } from '@angular/core';
import { UtilitaService } from '../../../services/utilita.service';

@Component({
  selector: 'app-pagamento-annullato',
  templateUrl: './pagamento-annullato.component.html',
  styleUrls: ['./pagamento-annullato.component.css']
})
export class PagamentoAnnullatoComponent implements OnInit {
  objpercorso: any;
  id: string= "923"


  constructor(private srvUtilita: UtilitaService) { }

  ngOnInit(): void {
  
  }

}
